export default "__VITE_ASSET__ATSzWoOF__"